import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { type AnchorHTMLAttributes, type ReactNode } from 'react';
import { Link } from '../Link/index.tsx';

export type TextLinkProps = {
  children: ReactNode;
  sx?: SystemStyleObject<Theme>;
  to: string;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

export const TextLink = ({ children, sx, to, ...rest }: TextLinkProps) => (
  <Link
    sx={{
      '&:hover,&:focus': {
        textDecoration: 'underline',
      },
      textDecoration: 'none',
      ...sx,
    }}
    to={to}
    {...rest}
  >
    {children}
  </Link>
);
